import type { MediaWrapperTypeEnum } from '@/utils/aspectRatioUtils';
import { getAspectRatioForImages } from '@/utils/aspectRatioUtils';

import { MediaWrapper } from '@/components/Cms/MediaWrapper';
import type { ContentfulImageWithFocalPointFragment } from '@/graphql/contentful/api';
import { useDeviceDetect } from '@/hooks/useDeviceDetect';

import type { CardProps } from '../../types';
import { CardContent } from '../CardContent';

import * as GS from '../../Card.styles';
import * as S from './SectionBannerType.styles';

export const SectionBannerType = (_props: CardProps) => {
  const {
    aspectRatio,
    backgroundAlignment,
    backgroundColor,
    className,
    contentAlignment,
    media,
    mediaAnimationEffect,
    mediaWrapperType,
    preload,
    sizes,
    textAlignment,
    type,
  } = _props;
  const { deviceType } = useDeviceDetect();

  const hasBackgroundImage = !!media?.video?.url || !!media?.image?.url;

  const aspectValue =
    aspectRatio ??
    getAspectRatioForImages(
      type as MediaWrapperTypeEnum,
      null,
      null,
      null,
      deviceType,
    );

  return (
    <S.Wrapper
      key={`${aspectValue?.x}:${aspectValue?.y}`}
      $aspectRatio={`${aspectValue?.x} / ${aspectValue?.y}`}
      $hasBackgroundImage={hasBackgroundImage}
      className={className}
      contentAlignment={contentAlignment}
      data-test-id={`${type}Wrapper`}
      mediaAnimationEffect={
        mediaAnimationEffect === 'zoomOnHover' ? mediaAnimationEffect : null
      }
      visibleInDesktop={_props.visibleInDesktop}
      visibleInMobile={_props.visibleInMobile}
    >
      {backgroundColor?.value && (
        <GS.Background $backgroundColor={backgroundColor?.value} />
      )}
      <GS.Media
        $backgroundAlignment={backgroundAlignment}
        data-test-id='SectionBannerMedia'
      >
        <MediaWrapper
          aspectRatio={aspectValue}
          {...(media as ContentfulImageWithFocalPointFragment)}
          mediaWrapperType={mediaWrapperType}
          preload={preload}
          sizes={sizes}
        />
      </GS.Media>

      <S.Content textAlignment={textAlignment}>
        <CardContent {..._props} />
      </S.Content>
    </S.Wrapper>
  );
};
